import { API_BASE } from "./apiBase";

const BASE = API_BASE;

const sent = new Set();

/** Fire-and-forget visit tracking. Never blocks or throws in the UI. */
export function trackEvent(type, key = "", { once = false } = {}) {
  const lang = localStorage.getItem("hrd_lang") || "en";
  const tag = `${type}:${key}:${lang}`;
  if (once) {
    if (sent.has(tag)) return;
    sent.add(tag);
  }
  fetch(`${BASE}/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, key, lang }),
    keepalive: true,
  }).catch(() => {});
}
